// ==========================================
// KOJI PRODUCT TEMPLATE - JS
// ==========================================
(function () {
  'use strict';

  const WISHLIST_KEY = 'koji_wishlist_data';
  const MSG_ADD_ERROR = 'Non è stato possibile aggiungere il prodotto. Riprova.';
  const MSG_UPDATE_ERROR = 'Non è stato possibile aggiornare il carrello. Riprova.';

  function vibrate(pattern) {
    if (navigator.vibrate) navigator.vibrate(pattern);
  }

  function readWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem(WISHLIST_KEY));
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) { /* storage non disponibile */ }
  }

  // Funzione globale (usata anche da altre sezioni)
  window.toggleProductWishlistItem = function (handle, title, price, image, btnElement) {
    const wishlist = readWishlist();
    const index = wishlist.findIndex(function (item) { return item.handle === handle; });
    let active;

    if (index > -1) {
      wishlist.splice(index, 1);
      active = false;
    } else {
      wishlist.push({ handle: handle, title: title, price: price, image: image });
      active = true;
      vibrate(50);
    }

    if (btnElement) {
      btnElement.classList.toggle('is-active', active);
      btnElement.setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    writeWishlist(wishlist);

    document.querySelectorAll('.koji-wishlist-badge').forEach(function (badge) {
      badge.textContent = wishlist.length;
      badge.classList.toggle('is-active', wishlist.length > 0);
    });
  };

  async function updateHeaderCartBadge(count) {
    let n = count;
    if (typeof n !== 'number') {
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        n = (await res.json()).item_count;
      } catch (e) {
        return;
      }
    }
    const badge = document.getElementById('koji-cart-badge');
    if (badge) {
      badge.textContent = n;
      badge.classList.toggle('is-active', n > 0);
    }
  }

  // ------------------------------------------
  // Listener globali (registrati una sola volta)
  // ------------------------------------------
  if (!window.__kojiProductBound) {
    window.__kojiProductBound = true;

    const closeAllPopups = function () {
      document.querySelectorAll('.koji-variant-popup.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
      const t = document.getElementById('koji-variant-badge-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    };

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.koji-variant-pop-container')) closeAllPopups();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPopups();
    });
    // Theme editor: reinizializza la section quando viene ricaricata
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.koji-product-wrapper').forEach(initWrapper);
    });
  }

  // ------------------------------------------
  // Init di una singola section prodotto
  // ------------------------------------------
  function initWrapper(root) {
    if (root.dataset.kojiInit === '1') return;
    root.dataset.kojiInit = '1';

    const $ = function (sel) { return root.querySelector(sel); };
    const $$ = function (sel) { return Array.from(root.querySelectorAll(sel)); };

    // ---------- 0. WISHLIST ----------
    const heart = $('.koji-btn-wishlist-main');
    if (heart) {
      const isActive = readWishlist().some(function (i) { return i.handle === heart.dataset.handle; });
      heart.classList.toggle('is-active', isActive);
      heart.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      heart.addEventListener('click', function () {
        window.toggleProductWishlistItem(
          heart.dataset.handle,
          heart.dataset.title,
          heart.dataset.price,
          heart.dataset.image || '',
          heart
        );
      });
    }

    // ---------- 1. TRAMA (LEGGI TUTTO) ----------
    const storyBtn = $('#koji-story-toggle');
    const storyContent = $('#koji-story-content');
    if (storyBtn && storyContent) {
      const measureStory = function () {
        if (storyContent.classList.contains('is-expanded')) return;
        storyContent.classList.remove('is-short');
        const isShort = storyContent.scrollHeight <= 130;
        storyContent.classList.toggle('is-short', isShort);
        storyBtn.hidden = isShort;
      };
      measureStory();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureStory);
      window.addEventListener('load', measureStory);
      let resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(measureStory, 150);
      });

      storyBtn.addEventListener('click', function () {
        const expanded = storyBtn.getAttribute('aria-expanded') === 'true';
        storyBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        storyContent.classList.toggle('is-expanded', !expanded);
      });
    }

    // ---------- 2. GALLERIA ----------
    const mainImage = $('#koji-main-product-img');
    const thumbs = $$('.koji-thumb-btn');

    function setMainImage(url, alt) {
      if (!mainImage || !url || mainImage.getAttribute('src') === url) return;
      mainImage.style.transform = 'scale(0.95)';
      mainImage.style.opacity = '0';
      const pre = new Image();
      const apply = function () {
        setTimeout(function () {
          mainImage.src = url;
          if (alt) mainImage.alt = alt;
          mainImage.style.transform = 'scale(1)';
          mainImage.style.opacity = '1';
        }, 200);
      };
      pre.onload = apply;
      pre.onerror = apply;
      pre.src = url;
    }

    function activateThumb(thumb) {
      thumbs.forEach(function (t) {
        const on = t === thumb;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        vibrate(10);
        activateThumb(thumb);
        const img = thumb.querySelector('img');
        setMainImage(thumb.getAttribute('data-img-url'), img ? img.alt : '');
      });
    });

    // ---------- 3. ACCORDIONS ----------
    $$('.koji-accordion-header').forEach(function (header) {
      const content = header.nextElementSibling;
      header.addEventListener('click', function () {
        vibrate(10);
        const expanded = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (content) content.inert = expanded;
      });
    });

    // ---------- 4. POP-UP VARIANT ----------
    const trigger = $('#koji-variant-badge-trigger');
    const popup = $('#koji-variant-popup');
    const closeBtn = $('#koji-popup-close');
    const popContainer = $('.koji-variant-pop-container');
    if (trigger && popup && popContainer) {
      const hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const openPopup = function () { popup.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); };
      const closePopup = function () { popup.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };

      if (hoverDevice) {
        popContainer.addEventListener('mouseenter', openPopup);
        popContainer.addEventListener('mouseleave', closePopup);
      }
      trigger.addEventListener('click', function (e) {
        // su desktop il click del mouse è già coperto dall'hover; la tastiera (detail 0) apre/chiude
        if (hoverDevice && e.detail !== 0) return;
        if (popup.classList.contains('is-open')) closePopup(); else openPopup();
      });
      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); closePopup(); });
    }

    // ---------- 5. VARIANTI + CARRELLO ----------
    const inputId = $('#koji-variant-id');
    const priceBox = $('#koji-price-box');
    const badgesBox = $('#koji-main-badges');
    const optionGroups = $$('.koji-option-values');
    const addDrawer = $('[data-koji-add-drawer]');
    const soldoutBtn = $('[data-koji-soldout]');
    const dynCheckout = $('.koji-dynamic-checkout');
    const cardWrap = $('[data-koji-product-card]');
    const msgBox = $('[data-koji-cart-message]');

    let variants = [];
    try {
      const jsonEl = $('#koji-variants-json');
      if (jsonEl) variants = JSON.parse(jsonEl.textContent);
    } catch (e) { variants = []; }

    let currentVariant = null;
    if (inputId) {
      currentVariant = variants.find(function (v) { return String(v.id) === String(inputId.value); }) || null;
    }

    function showMessage(text) {
      if (!msgBox) return;
      msgBox.textContent = text;
      msgBox.hidden = false;
    }
    function hideMessage() {
      if (!msgBox) return;
      msgBox.textContent = '';
      msgBox.hidden = true;
    }

    // ----- selezione opzioni -----
    function getSelection() {
      return optionGroups.map(function (g) {
        const sel = g.querySelector('.koji-option-btn.is-selected');
        return sel ? sel.dataset.value : null;
      });
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.length === selection.length && v.options.every(function (o, i) { return o === selection[i]; });
      }) || null;
    }

    function selectOptions(values) {
      optionGroups.forEach(function (group, i) {
        group.querySelectorAll('.koji-option-btn').forEach(function (b) {
          const on = b.dataset.value === values[i];
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    }

    function markSoldOutOptions() {
      const sel = getSelection();
      optionGroups.forEach(function (group, i) {
        group.querySelectorAll('.koji-option-btn').forEach(function (btn) {
          const val = btn.dataset.value;
          const ok = variants.some(function (v) {
            return v.available && v.options[i] === val && v.options.every(function (o, j) { return j === i || o === sel[j]; });
          });
          btn.classList.toggle('is-soldout', !ok);
        });
      });
    }

    // ----- render prezzo / badge / disponibilità -----
    function renderPrice(v) {
      if (!priceBox || !v) return;
      priceBox.textContent = '';
      if (v.compare) {
        const old = document.createElement('span');
        old.className = 'koji-product-price-old';
        old.textContent = v.compare;
        priceBox.appendChild(old);
      }
      const cur = document.createElement('span');
      cur.className = 'koji-product-price' + (v.compare ? ' is-sale' : '');
      cur.textContent = v.price;
      priceBox.appendChild(cur);
      priceBox.style.transform = 'scale(1.1)';
      setTimeout(function () { priceBox.style.transform = 'scale(1)'; }, 150);
    }

    function renderBadges(v) {
      if (!badgesBox) return;
      badgesBox.textContent = '';
      const badge = document.createElement('span');
      if (!v || !v.available) {
        badge.className = 'koji-badge koji-badge-soldout';
        badge.textContent = '[ OFFLINE ]';
      } else if (v.compare_cents > v.price_cents) {
        const pct = Math.round((v.compare_cents - v.price_cents) * 100 / v.compare_cents);
        badge.className = 'koji-badge koji-badge-sale';
        badge.textContent = '[ DROP -' + pct + '% ]';
      } else {
        return;
      }
      badgesBox.appendChild(badge);
    }

    function renderAvailability(v) {
      const available = !!(v && v.available);
      if (addDrawer) addDrawer.hidden = !available;
      if (soldoutBtn) soldoutBtn.hidden = available;
      if (dynCheckout) dynCheckout.hidden = !available;
    }

    // ----- stato carrello -----
    const addBtn = cardWrap ? cardWrap.querySelector('.koji-js-add-btn-main') : null;
    const btnText = cardWrap ? cardWrap.querySelector('.koji-drawer-text-main') : null;
    const qtyNum = cardWrap ? cardWrap.querySelector('.koji-d-qty-num-main') : null;
    const btnMinus = cardWrap ? cardWrap.querySelector('.koji-d-qty-minus-main') : null;
    const btnPlus = cardWrap ? cardWrap.querySelector('.koji-d-qty-plus-main') : null;
    const cartReady = !!(cardWrap && addBtn && qtyNum && btnMinus && btnPlus && inputId);
    const originalText = btnText ? btnText.textContent : 'Aggiungi al carrello';

    let qtyInCart = 0;
    let pending = null;
    let pendingTimer = null;

    function maxQty() {
      return currentVariant && typeof currentVariant.max_qty === 'number' ? currentVariant.max_qty : Infinity;
    }

    function updatePlusUI() {
      if (!btnPlus) return;
      const blocked = qtyInCart >= maxQty();
      btnPlus.classList.toggle('is-disabled', blocked);
      btnPlus.disabled = blocked;
    }

    function applyQty(n) {
      qtyInCart = n;
      if (!cartReady) return;
      qtyNum.textContent = n;
      cardWrap.classList.remove('is-success');
      cardWrap.classList.toggle('is-qty-mode', n > 0);
      if (btnText) btnText.textContent = n > 0 ? 'Preso!' : originalText;
      updatePlusUI();
    }

    async function syncCartState() {
      if (!cartReady || !currentVariant) return;
      const variantId = currentVariant.id;
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        if (!currentVariant || currentVariant.id !== variantId || pending) return;
        const line = cart.items.find(function (i) { return i.variant_id === variantId; });
        applyQty(line ? line.quantity : 0);
      } catch (e) { /* silenzioso */ }
    }

    async function executeCartUpdate(job) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: String(job.variantId), quantity: job.qty })
        });
        const cart = await res.json();
        if (!res.ok) throw new Error(cart.description || cart.message || MSG_UPDATE_ERROR);
        updateHeaderCartBadge(cart.item_count);
        window.dispatchEvent(new Event('cart:updated'));
        if (currentVariant && currentVariant.id === job.variantId && !pending) {
          const line = cart.items.find(function (i) { return i.variant_id === job.variantId; });
          applyQty(line ? line.quantity : 0);
        }
      } catch (err) {
        showMessage(err && err.message ? err.message : MSG_UPDATE_ERROR);
        if (currentVariant && currentVariant.id === job.variantId) {
          pending = null;
          syncCartState();
        }
      }
    }

    function flushPending() {
      clearTimeout(pendingTimer);
      if (!pending) return;
      const job = pending;
      pending = null;
      executeCartUpdate(job);
    }

    function scheduleUpdate() {
      pending = { variantId: currentVariant.id, qty: qtyInCart };
      clearTimeout(pendingTimer);
      pendingTimer = setTimeout(flushPending, 400);
    }

    function pulse(el, scale) {
      el.style.transform = 'scale(' + scale + ')';
      setTimeout(function () { el.style.transform = 'scale(1)'; }, 150);
    }

    if (cartReady) {
      addBtn.addEventListener('click', async function (e) {
        if (cardWrap.classList.contains('is-qty-mode')) return;
        e.preventDefault();
        if (!currentVariant || !currentVariant.available) return;

        hideMessage();
        vibrate([15, 30, 15]);
        addBtn.blur();
        addBtn.classList.add('is-loading');

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: 1 }] })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || MSG_ADD_ERROR);

          const line = data.items && data.items[0];
          addBtn.classList.remove('is-loading');
          qtyInCart = line ? line.quantity : 1;
          qtyNum.textContent = qtyInCart;
          if (btnText) btnText.textContent = 'Preso!';
          cardWrap.classList.add('is-success');
          updatePlusUI();
          updateHeaderCartBadge();
          window.dispatchEvent(new Event('cart:updated'));
          setTimeout(function () {
            cardWrap.classList.remove('is-success');
            cardWrap.classList.add('is-qty-mode');
          }, 800);
        } catch (err) {
          addBtn.classList.remove('is-loading');
          showMessage(err && err.message ? err.message : MSG_ADD_ERROR);
          syncCartState();
        }
      });

      btnPlus.addEventListener('click', function (e) {
        e.preventDefault();
        if (qtyInCart >= maxQty()) { vibrate([30, 50, 30]); return; }
        vibrate(15);
        hideMessage();
        qtyInCart++;
        qtyNum.textContent = qtyInCart;
        pulse(qtyNum, 1.3);
        updatePlusUI();
        scheduleUpdate();
      });

      btnMinus.addEventListener('click', function (e) {
        e.preventDefault();
        if (qtyInCart <= 0) return;
        vibrate(15);
        hideMessage();
        qtyInCart--;
        qtyNum.textContent = qtyInCart;
        pulse(qtyNum, 0.7);
        updatePlusUI();
        scheduleUpdate();
      });
    }

    // ----- cambio variante -----
    function setVariant(v) {
      // salva subito eventuali modifiche di quantità in sospeso per la variante precedente
      flushPending();
      currentVariant = v;
      if (inputId) inputId.value = v ? v.id : '';
      hideMessage();

      renderPrice(v);
      renderBadges(v);
      renderAvailability(v);
      markSoldOutOptions();

      if (v && v.image) {
        const thumb = thumbs.find(function (t) { return t.getAttribute('data-img-url') === v.image; });
        if (thumb) activateThumb(thumb);
        const img = thumb ? thumb.querySelector('img') : null;
        setMainImage(v.image, img ? img.alt : '');
      }

      if (v && variants.length > 1) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url.toString());
        } catch (e) { /* ignora */ }
      }

      applyQty(0);
      syncCartState();
    }

    optionGroups.forEach(function (group, groupIndex) {
      group.addEventListener('click', function (e) {
        const btn = e.target.closest('.koji-option-btn');
        if (!btn || btn.classList.contains('is-selected')) return;
        vibrate(15);

        group.querySelectorAll('.koji-option-btn').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');

        let v = findVariant(getSelection());
        if (!v) {
          // combinazione inesistente: sceglie la variante più vicina con il valore appena cliccato
          const val = btn.dataset.value;
          v = variants.find(function (x) { return x.options[groupIndex] === val && x.available; })
            || variants.find(function (x) { return x.options[groupIndex] === val; })
            || null;
          if (v) selectOptions(v.options);
        }
        setVariant(v);
      });
    });

    // ----- stato iniziale -----
    markSoldOutOptions();
    renderAvailability(currentVariant);
    updatePlusUI();
    syncCartState();
  }

  function initAll() {
    document.querySelectorAll('.koji-product-wrapper').forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
